import axios from "axios";

const url = process.env.REACT_APP_API_URL_MASTER
const contentType = 'application/json'

export default class MasterService {

    listBahanKemasan(ket, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (ket !== null) {
            param += '&ket=' + ket
        }
        return axios.get(url + '/bahan-kemasan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getBahanKemasanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/bahan-kemasan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addBahanKemasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/bahan-kemasan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editBahanKemasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/bahan-kemasan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteBahanKemasanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/bahan-kemasan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listBentukIkan(kdBentuk, ketBentuk, hidup, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kdBentuk !== null) {
            param += '&kdBentuk=' + kdBentuk
        }
        if (ketBentuk !== null) {
            param += '&ketBentuk=' + ketBentuk
        }
        if (hidup !== null) {
            param += '&hidup=' + hidup
        }
        return axios.get(url + '/bentuk?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getBentukIkanById(kdBentuk) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/bentuk/' + kdBentuk, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addBentukIkan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/bentuk', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editBentukIkan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/bentuk', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteBentukIkanById(kdBentuk) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/bentuk/' + kdBentuk, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listCaraAngkut(caraAngkut, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (caraAngkut !== null) {
            param += '&caraAngkut=' + caraAngkut
        }
        return axios.get(url + '/cara-angkut?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getCaraAngkutById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/cara-angkut/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addCaraAngkut(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/cara-angkut', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editCaraAngkut(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/cara-angkut', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteCaraAngkutById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/cara-angkut/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listDisposisi(nmDisposisi, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nmDisposisi != null) {
            param += '&nmDisposisi=' + nmDisposisi
        }
        return axios.get(url + '/disposisi?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getDisposisiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/disposisi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addDisposisi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/disposisi', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editDisposisi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/disposisi', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteDisposisiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/disposisi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listHasilUji(targetUji, jenisUji, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (targetUji != null) {
            param += '&targetUji=' + targetUji
        }
        if (jenisUji != null) {
            param += '&jenisUji=' + jenisUji
        }
        return axios.get(url + '/hasil-uji?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getHasilUjiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hasil-uji/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addHasilUji(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hasil-uji', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editHasilUji(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/hasil-uji', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteHasilUjiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/hasil-uji/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listMasterIkan(nmDagang, nmUmum, nmLatin, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nmDagang != null) {
            param += '&nmDagang=' + nmDagang
        }
        if (nmUmum != null) {
            param += '&nmUmum=' + nmUmum
        }
        if (nmLatin != null) {
            param += '&nmLatin=' + nmLatin
        }
        return axios.get(url + '/master-ikan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listMasterIkanTrader(kodeTrader, nmDagang, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nmDagang !== null) {
            param += '&nmDagang=' + nmDagang
        }
        return axios.get(url + '/master-ikan-trader?page=' + page + '&size=' + size + '&kodeTrader=' + kodeTrader + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getMasterIkanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/master-ikan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addMasterIkan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/master-ikan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editMasterIkan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/master-ikan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteMasterIkanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/master-ikan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisContainer(jenisCnt, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (jenisCnt != null) {
            param += '&jenisCnt=' + jenisCnt
        }
        return axios.get(url + '/jenis-container?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisContainerById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/jenis-container/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addJenisContainer(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/jenis-container', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editJenisContainer(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/jenis-container', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteJenisContainerById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/jenis-container/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisDok(jenisDok, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (jenisDok != null) {
            param += '&jenisDok=' + jenisDok
        }
        return axios.get(url + '/jenis-dokumen?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisDokById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/jenis-dokumen/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addJenisDok(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/jenis-dokumen', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editJenisDok(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/jenis-dokumen', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteJenisDokById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/jenis-dokumen/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisHcm(kdHcm, uraianHcm, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kdHcm != null) {
            param += '&kdHcm=' + kdHcm
        }
        if (uraianHcm != null) {
            param += '&uraianHcm=' + uraianHcm
        }
        return axios.get(url + '/jenis-hcm?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisHcmById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/jenis-hcm/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addJenisHcm(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/jenis-hcm', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editJenisHcm(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/jenis-hcm', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteJenisHcmById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/jenis-hcm/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisIdentitas(jenisId, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (jenisId != null) {
            param += '&jenisId=' + jenisId
        }
        return axios.get(url + '/jenis-identitas?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisIdentitasById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/jenis-identitas/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addJenisIdentitas(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/jenis-identitas', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editJenisIdentitas(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/jenis-identitas', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteJenisIdentitasById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/jenis-identitas/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisKegiatan(nmKegiatan, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nmKegiatan != null) {
            param += '&nmKegiatan=' + nmKegiatan
        }
        return axios.get(url + '/jenis-kegiatan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisKegiatanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/jenis-kegiatan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addJenisKegiatan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/jenis-kegiatan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editJenisKegiatan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/jenis-kegiatan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteJenisKegiatanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/jenis-kegiatan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisKomoditi(ket, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (ket != null) {
            param += '&ket=' + ket
        }
        return axios.get(url + '/jenis-komoditi?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisKomoditiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return id !== undefined && axios.get(url + '/jenis-komoditi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addJenisKomoditi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/jenis-komoditi', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editJenisKomoditi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/jenis-komoditi', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteJenisKomoditiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/jenis-komoditi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisProduk(jenisProduk, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (jenisProduk != null) {
            param += '&jenisProduk=' + jenisProduk
        }
        return axios.get(url + '/jenis-produk?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisProdukById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/jenis-produk/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addJenisProduk(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/jenis-produk', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editJenisProduk(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/jenis-produk', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteJenisProdukById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/jenis-produk/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisUji(ketJenisUji, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (ketJenisUji != null) {
            param += '&ketJenisUji=' + ketJenisUji
        }
        return axios.get(url + '/jenis-uji?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisUjiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/jenis-uji/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addJenisUji(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/jenis-uji', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editJenisUji(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/jenis-uji', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteJenisUjiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/jenis-uji/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKecamatan(kodeKota, uraianKecamatan, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kodeKota != null) {
            param += '&kodeKota=' + kodeKota
        }
        if (uraianKecamatan != null) {
            param += '&uraianKecamatan=' + uraianKecamatan
        }
        return axios.get(url + '/kecamatan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKecamatanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/kecamatan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addKecamatan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/kecamatan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editKecamatan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/kecamatan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteKecamatanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/kecamatan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKelurahan(kodeKecamatan, uraianKel, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kodeKecamatan != null) {
            param += '&kodeKecamatan=' + kodeKecamatan
        }
        if (uraianKel != null) {
            param += '&uraianKel=' + uraianKel
        }
        return axios.get(url + '/kelurahan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKelurahanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/kelurahan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addKelurahan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/kelurahan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editKelurahan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/kelurahan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteKelurahanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/kelurahan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKemasan(uraianKemasan, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (uraianKemasan != null) {
            param += '&uraianKemasan=' + uraianKemasan
        }
        return axios.get(url + '/kemasan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKemasanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/kemasan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addKemasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/kemasan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editKemasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/kemasan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteKemasanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/kemasan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKesimpulan(kdKesimpulan, kesimpulan, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kdKesimpulan != null) {
            param += '&kdKesimpulan=' + kdKesimpulan
        }
        if (kesimpulan != null) {
            param += '&kesimpulan=' + kesimpulan
        }
        return axios.get(url + '/kesimpulan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKesimpulanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/kesimpulan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addKesimpulan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/kesimpulan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editKesimpulan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/kesimpulan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteKesimpulanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/kesimpulan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listHs(kodeHs, uraian, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kodeHs != null) {
            param += '&kodeHs=' + kodeHs
        }
        if (uraian != null) {
            param += '&uraian=' + uraian
        }
        return axios.get(url + '/hs?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getHsById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hs/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getHsCode(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hscode/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addHs(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hs', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editHs(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/hs', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteHsById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/hs/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKota(kodePropinsi, uraianKota, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kodePropinsi != null) {
            param += '&kodePropinsi=' + kodePropinsi
        }
        if (uraianKota != null) {
            param += '&uraianKota=' + uraianKota
        }
        return axios.get(url + '/kota?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKotaById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/kota/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addKota(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/kota', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editKota(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/kota', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteKotaById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/kota/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listMaksudPengiriman(maksudPengiriman, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (maksudPengiriman != null) {
            param += '&maksudPengiriman=' + maksudPengiriman
        }
        return axios.get(url + '/maksud-pengiriman?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getMaksudPengirimanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return id !== undefined && axios.get(url + '/maksud-pengiriman/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addMaksudPengiriman(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/maksud-pengiriman', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editMaksudPengiriman(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/maksud-pengiriman', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteMaksudPengirimanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/maksud-pengiriman/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listMatauang(kode, uraian, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kode != null) {
            param += '&kode=' + kode
        }
        if (uraian != null) {
            param += '&uraian=' + uraian
        }
        return axios.get(url + '/matauang?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getMatauangById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/matauang/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addMatauang(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/matauang', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editMatauang(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/matauang', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteMatauangById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/matauang/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listMetodeLab(metodeUji, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (metodeUji != null) {
            param += '&metodeUji=' + metodeUji
        }
        return axios.get(url + '/metode-lab?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getMetodeLabById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/metode-lab/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addMetodeLab(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/metode-lab', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editMetodeLab(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/metode-lab', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteMetodeLabById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/metode-lab/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listNegara(uraianNegara, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (uraianNegara != null) {
            param += '&uraianNegara=' + uraianNegara
        }
        return axios.get(url + '/negara?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getNegaraById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/negara/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addNegara(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/negara', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editNegara(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/negara', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteNegaraById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/negara/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPelabuhan(kodePelabuhan, jnsPelabuhan, uraianPelabuhan, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kodePelabuhan !== null) {
            param += '&kodePelabuhan=' + kodePelabuhan
        }
        if (jnsPelabuhan !== null) {
            param += '&jnsPelabuhan=' + jnsPelabuhan
        }
        if (uraianPelabuhan !== null) {
            param += '&uraianPelabuhan=' + uraianPelabuhan
        }
        return axios.get(url + '/pelabuhan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPelabuhanById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/pelabuhan-by-id', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    addPelabuhan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/pelabuhan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPelabuhan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/pelabuhan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deletePelabuhanById(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/pelabuhan', {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            },
            data: jsonData
        })
    }

    listPropinsi(uraianPropinsi, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (uraianPropinsi != null) {
            param += '&uraianPropinsi=' + uraianPropinsi
        }
        return axios.get(url + '/propinsi?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPropinsiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/propinsi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addPropinsi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/propinsi', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editPropinsi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/propinsi', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deletePropinsiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/propinsi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listIkanSatuan(kategoriCmdts, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kategoriCmdts != null) {
            param += '&kategoriCmdts=' + kategoriCmdts
        }
        return axios.get(url + '/ikan-satuan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getIkanSatuanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ikan-satuan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addIkanSatuan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ikan-satuan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editIkanSatuan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ikan-satuan', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteIkanSatuanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ikan-satuan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisTarif(kelTarif, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (kelTarif != null) {
            param += '&kelTarif=' + kelTarif
        }
        return axios.get(url + '/jenis-tarif?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisTarifById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/jenis-tarif/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKelTarif(page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/kelompok-tarif?page=' + page + '&size=' + size, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKelTarifById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/kelompok-tarif/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listTarifPnbp(jnPemeriksaan, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (jnPemeriksaan != null) {
            param += '&jnPemeriksaan=' + jnPemeriksaan
        }
        return axios.get(url + '/tarif-pnbp?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listTarifPnbpV2(parentId) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/tarif-pnbp-v2/' + parentId, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getTarifPnbpById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/tarif-pnbp/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addTarifPnbp(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/tarif-pnbp', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editTarifPnbp(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/tarif-pnbp', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteTarifPnbpById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/tarif-pnbp/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listTemperatur(jnsTemperature, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (jnsTemperature != null) {
            param += '&jnsTemperature=' + jnsTemperature
        }
        return axios.get(url + '/jenis-temperatur?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getTemperaturById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/jenis-temperatur/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addTemperatur(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/jenis-temperatur', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editTemperatur(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/jenis-temperatur', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteTemperaturById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/jenis-temperatur/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listTipeContainer(typeCnt, kode, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (typeCnt != null) {
            param += '&typeCnt=' + typeCnt
        }
        if (kode != null) {
            param += '&kode=' + kode
        }
        return axios.get(url + '/tipe-container?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getTipeContainerById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/tipe-container/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addTipeContainer(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/tipe-container', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editTipeContainer(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/tipe-container', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteTipeContainerById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/tipe-container/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listUkuranContainer(ukuranCnt, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (ukuranCnt != null) {
            param += '&ukuranCnt=' + ukuranCnt
        }
        return axios.get(url + '/ukuran-container?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getUkuranContainerById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ukuran-container/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addUkuranContainer(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ukuran-container', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editUkuranContainer(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/ukuran-container', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteUkuranContainerById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ukuran-container/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listWpp(wpp, wilayah, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (wpp != null) {
            param += '&wpp=' + wpp
        }
        if (wilayah != null) {
            param += '&wilayah=' + wilayah
        }
        return axios.get(url + '/wpp?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getWppById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/wpp/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addWpp(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/wpp', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editWpp(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/wpp', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteWppById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/wpp/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listStatusDok(page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/status-dokumen?page=' + page + '&size=' + size, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getStatusDokById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/status-dokumen/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addStatus(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/status-dokumen', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editStatusDok(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/status-dokumen', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteStatusDokById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/status-dokumen/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listDokumenWajib(idJnsDok, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (idJnsDok !== 0) {
            param = '&idJnsDok=' + idJnsDok
        } else {
            param = '&idJnsDok=0'
        }
        return axios.get(url + '/dokumen-wajib?page=' + page + '&size=' + size + '&status=1' + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getDokumenWajibById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/dokumen-wajib/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addDokumenWajib(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/dokumen-wajib', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editDokumenWajib(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/dokumen-wajib', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteDokumenWajibById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/dokumen-wajib/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKomponenVerlap(page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/komponen-verlap?page=' + page + '&size=' + size, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKomponenVerlapById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/komponen-verlap/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addKomponenVerlap(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/komponen-verlap', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    editKomponenVerlap(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.put(url + '/komponen-verlap', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    deleteKomponenVerlapById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/komponen-verlap/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listZonasi(page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/zonasi?page=' + page + '&size=' + size, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getZonasiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/zonasi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getZonasiByKode(kode) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/zonasi-by-kode/' + kode, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    addIkanTrader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/add-ikan-trader', jsonData, {
            headers: {
                'Content-Type': contentType,
                'Authorization': Auth
            }
        })
    }

    listKelompokIkan(nmKelIkan, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (nmKelIkan !== null) {
            param = '&nmKelIkan=' + nmKelIkan
        }

        return axios.get(url + '/ikan-kelompok?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKelompokIkan(idKelIkan) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token

        return axios.get(url + '/ikan-kelompok/' + idKelIkan, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listSatuan(search, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = '';
        if (search !== null) {
            param = '&search=' + search
        }

        return axios.get(url + '/satuan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getSatuanByKd(kode) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token

        return axios.get(url + '/satuan/' + kode, {
            headers: {
                'Authorization': Auth
            }
        })
    }
}